import { Navigate, RouteObject, useLocation, useParams } from 'react-router-dom';
import { WorkspaceErrorElement } from '../components/errors/RouteErrorElement';
import { loadRouteChunk } from '../forge/utils/lazyRouteModule';
import { LurkerLayout } from './components/layout/LurkerLayout';
import { lurkerCameraDayPath, LURKER_DASHBOARD_PATH, LURKER_ROOT } from './paths';

function CameraDayRedirect() {
  const { cameraDayId = '' } = useParams<{ cameraDayId: string }>();
  // A link to an item and capture keeps them.
  const { search } = useLocation();
  return <Navigate to={`${lurkerCameraDayPath(cameraDayId)}${search}`} replace />;
}

// Pages load lazily, as in Archon, so the Lurker pages and their styles stay out of the main bundle;
// the layout stays eager to render while a page chunk is in flight.
export const lurkerRoutes: RouteObject = {
  path: LURKER_ROOT,
  element: <LurkerLayout />,
  children: [
    {
      errorElement: (
        <WorkspaceErrorElement homePath={LURKER_DASHBOARD_PATH} homeLabel="Back to Dashboard" />
      ),
      children: [
        { index: true, element: <Navigate to="dashboard" replace /> },
        {
          path: 'dashboard',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/DashboardPage'))).DashboardPage,
          }),
        },
        {
          path: 'camera-days',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/CameraDaysPage')))
              .CameraDaysPage,
          }),
        },
        { path: 'camera-days/:cameraDayId', element: <CameraDayRedirect /> },
        {
          path: 'camera-days/:cameraDayId/:view',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/CameraDayPage'))).CameraDayPage,
          }),
        },
        {
          path: 'strategies',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/StrategiesPage')))
              .StrategiesPage,
          }),
        },
        {
          path: 'labeling',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/BatchesPage'))).BatchesPage,
          }),
        },
        {
          path: 'labeling/:batchId',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/BatchPage'))).BatchPage,
          }),
        },
        {
          path: 'relabel',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/RelabelPage'))).RelabelPage,
          }),
        },
        {
          path: 'labeling-stats',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/LabelingStatsPage')))
              .LabelingStatsPage,
          }),
        },
        {
          path: 'relabel/:chainId',
          lazy: async () => ({
            Component: (await loadRouteChunk(() => import('./pages/BatchPage'))).RelabelQueuePage,
          }),
        },
      ],
    },
  ],
};
